import React, { useEffect, useState, useContext } from 'react'
import { GlobalContext } from '../../GlobalContext'
import { getDate } from '../../utils/getDate'
import { Link } from 'react-router-dom'


type Props = {
    thisReminder: ObjectStringKeyAnyValue

}

function ChecklistReminderAlert({
    thisReminder
}: Props) {

    const {
        tableData,
        t
    } = useContext(GlobalContext)


    const thisChecklistId = thisReminder['ChecklistId']
    const thisChecklist = tableData && tableData['Checklists'] && tableData['Checklists'][thisChecklistId] || {}
    const checklistName = thisChecklist['ChecklistName'] || t('Dashboard.RemindersPanel.ChecklistReminderAlert.unknownChecklist')
    const readableNextDueDate = thisReminder['nextDueTimeStamp'] && getDate(thisReminder['nextDueTimeStamp'], 'formattedDate') || ''
    const reminderStatus = thisReminder['reminderStatus'] || ''

    return <Link to={`/start-checklist/${thisChecklistId}`}><div
        className={`
       bg-white text-sm text-black w-full flex flex-row items-center gap-2 px-2 py-2 rounded hover:opacity-80 cursor-pointer`}

    >
        {reminderStatus === 'overdue' && <div className={`text-4xl`}>🚨</div>}
        {reminderStatus === 'showReminder' && <div className={`text-4xl`}>⏰</div>}
        {reminderStatus !== 'showReminder' && reminderStatus !== 'overdue' && <div className={`text-4xl`}>📆</div>}

        <div className={`flex flex-col justify-between items-start gap-1`}>
            <div className={`w-full flex flex-col`}>
                <p className={``}>{checklistName}</p>
                <p className={`text-xs text-gray-700`}>
                    {t('Dashboard.RemindersPanel.ChecklistReminderAlert.dueBy')} {readableNextDueDate}
                    {reminderStatus === 'overdue' && <span className={`text-sm text-red-600 font-semibold pl-1`}>{t('Dashboard.RemindersPanel.ChecklistReminderAlert.overdue')}</span>}
                </p>

            </div>
        </div>
    </div></Link>
}
export default ChecklistReminderAlert